<div class="spec-filter-root" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <button
    mat-stroked-button
    type="button"
    class="spec-filter-trigger"
    [disabled]="!productTypeId"
    (click)="toggleOpen()">
    <mat-icon class="spec-filter-trigger-icon">filter_alt</mat-icon>
    <span class="spec-filter-trigger-label">{{ triggerLabel }}</span>
    <mat-icon class="spec-filter-trigger-caret">{{ isOpen ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
  </button>

  <div *ngIf="displayChips.length" class="spec-filter-chips">
    <span class="spec-filter-chip" *ngFor="let chip of displayChips; trackBy: trackByChipId">
      <span class="spec-filter-chip-label">{{ chip.name }}</span>
      <button
        mat-icon-button
        type="button"
        class="spec-filter-chip-remove"
        aria-label="Remove specification filter"
        (click)="removeChip(chip.id)">
        <mat-icon>cancel</mat-icon>
      </button>
    </span>
    <button
      mat-button
      type="button"
      class="spec-filter-clear-all"
      color="accent"
      (click)="clearAll()">
      Clear all
    </button>
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayFlexibleDimensions]="true"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="8"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  (backdropClick)="closePanel()"
  (detach)="closePanel()">
  <div class="spec-filter-panel mat-elevation-z4">
    <div class="spec-filter-panel-header">
      <span class="spec-filter-panel-title">Specifications</span>
      <button
        mat-button
        type="button"
        color="accent"
        [disabled]="tickedCount === 0"
        (click)="clearAll()">
        Clear
      </button>
    </div>

    <div *ngIf="loading" class="spec-filter-loading">
      <mat-progress-spinner diameter="24" mode="indeterminate"></mat-progress-spinner>
      <span>Loading…</span>
    </div>

    <div *ngIf="!loading && !hasOptions" class="spec-filter-empty">
      No specifications available for this product type.
    </div>

    <div *ngIf="!loading && hasOptions" class="spec-filter-tree">
      <div class="spec-filter-axis"
           [class.spec-filter-axis-grouped]="axis.children?.length"
           *ngFor="let axis of rootNodes; trackBy: trackByNodeId">
        <ng-container *ngIf="axis.spec.selectable; else axisHeader">
          <mat-checkbox
            [class.spec-filter-axis-title]="axis.children?.length"
            [checked]="isTicked(axis.spec.id)"
            (change)="onTick(axis, $event.checked)">
            {{ axis.spec.name }}
          </mat-checkbox>
        </ng-container>
        <ng-template #axisHeader>
          <div class="spec-filter-axis-title">{{ axis.spec.name }}</div>
        </ng-template>
        <ng-container *ngIf="axis.children?.length">
          <ng-container *ngTemplateOutlet="treeTpl; context: { nodes: axis.children, baseDepth: 1 }"></ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #treeTpl let-nodes="nodes" let-baseDepth="baseDepth">
  <ng-container *ngFor="let node of nodes; trackBy: trackByNodeId">
    <div class="spec-filter-node" [style.padding-left.px]="(node.depth - (baseDepth || 0)) * 16">
      <mat-checkbox
        *ngIf="node.spec.selectable; else headerTpl"
        [checked]="isTicked(node.spec.id)"
        (change)="onTick(node, $event.checked)">
        {{ node.spec.name }}
      </mat-checkbox>
      <ng-template #headerTpl>
        <div class="spec-filter-header">{{ node.spec.name }}</div>
      </ng-template>
    </div>
    <ng-container *ngIf="node.children?.length">
      <ng-container *ngTemplateOutlet="treeTpl; context: { nodes: node.children, baseDepth: baseDepth || 0 }"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>
